import {daActions} from './dependency-analysis.actions';

export const initialState = {
  instances: [],
  ddSchemas: [],
  graph: null,
  impact: null,
  ddl: null,
  columnsByObject: {},
  refreshResult: null,
  isLoading: [],
  error: [],
};

const dependencyAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case daActions.LOAD_INSTANCES_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadInstances']};
    case daActions.LOAD_INSTANCES_SUCCESS:
      return {
        ...state,
        instances: (action.payload && action.payload.response) ? action.payload.response : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadInstances'),
        error: [],
      };
    case daActions.LOAD_INSTANCES_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadInstances'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.LOAD_DD_SCHEMAS_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadDdSchemas']};
    case daActions.LOAD_DD_SCHEMAS_SUCCESS:
      return {
        ...state,
        ddSchemas: (action.payload && action.payload.response) ? action.payload.response : [],
        isLoading: state.isLoading.filter((k) => k !== 'loadDdSchemas'),
        error: [],
      };
    case daActions.LOAD_DD_SCHEMAS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadDdSchemas'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.LOAD_GRAPH_REQUEST:
      return {...state, graph: null, isLoading: [...state.isLoading, 'loadGraph']};
    case daActions.LOAD_GRAPH_SUCCESS:
      return {
        ...state,
        graph: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'loadGraph'),
        error: [],
      };
    case daActions.LOAD_GRAPH_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadGraph'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.LOAD_IMPACT_REQUEST:
      return {...state, impact: null, isLoading: [...state.isLoading, 'loadImpact']};
    case daActions.LOAD_IMPACT_SUCCESS:
      return {
        ...state,
        impact: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'loadImpact'),
        error: [],
      };
    case daActions.LOAD_IMPACT_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadImpact'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.LOAD_DDL_REQUEST:
      return {...state, ddl: null, isLoading: [...state.isLoading, 'loadDdl']};
    case daActions.LOAD_DDL_SUCCESS:
      return {
        ...state,
        ddl: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'loadDdl'),
        error: [],
      };
    case daActions.LOAD_DDL_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadDdl'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.LOAD_COLUMNS_REQUEST:
      return {...state, isLoading: [...state.isLoading, 'loadColumns']};
    case daActions.LOAD_COLUMNS_SUCCESS: {
      const incoming = (action.payload && action.payload.response) ? action.payload.response : {};
      return {
        ...state,
        columnsByObject: {...state.columnsByObject, ...incoming},
        isLoading: state.isLoading.filter((k) => k !== 'loadColumns'),
        error: [],
      };
    }
    case daActions.LOAD_COLUMNS_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'loadColumns'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    case daActions.REFRESH_REQUEST:
      return {...state, refreshResult: null, isLoading: [...state.isLoading, 'refresh']};
    case daActions.REFRESH_SUCCESS:
      return {
        ...state,
        refreshResult: (action.payload && action.payload.response) ? action.payload.response : null,
        isLoading: state.isLoading.filter((k) => k !== 'refresh'),
        error: [],
      };
    case daActions.REFRESH_FAILURE:
      return {
        ...state,
        isLoading: state.isLoading.filter((k) => k !== 'refresh'),
        error: [...state.error, action.payload && action.payload.response && action.payload.response.status],
      };

    default:
      return state;
  }
};

export default dependencyAnalysisReducer;
